import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useInView } from 'react-intersection-observer';
import { useHistory } from 'react-router-dom';
import { GetTitle } from '../board/boardTitle';
import { getBreadScrumb } from '../board/breadscrumb';
import { AsideProfessor } from '../../_layout/aside-professor';

import server from '../../_api/backend';
import * as toast from '../../_store/slice/toast';

export function SampleBook() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [searchVisable, setSearchVisable] = useState(false);
  const [book, setBook] = useState<any>();
  const [quantity, setQuantity] = useState(1);
  const [email, setEmail] = useState(window.localStorage.getItem('email') || '');
  const [phone1, setPhone1] = useState('');
  const [phone2, setPhone2] = useState('');
  const [phone3, setPhone3] = useState('');
  const [address, setAddress] = useState('');
  const [contents, setContents] = useState('');

  const [searchText, setSearchText] = useState('');

  const [listItem, setListItem] = useState<any>();

  const [ref, inView] = useInView();
  const [loading, setLoading] = useState(false);
  const [last, setLast] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);

  const emailRule = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;
  const cellPhoneRule = /^\d{3}-\d{3,4}-\d{4}$/;

  function validation() {
    const hp = `${phone1}-${phone2}-${phone3}`;
    if (book === undefined) {
      dispatch(
        toast.error({ message: '책을 선택 하시기 바랍니다.', title: '필수 입력 항목 누락' })
      );
      return false;
    }
    if (quantity === 0) {
      dispatch(toast.error({ message: '수량이 잘못되었습니다.', title: '필수 입력 항목 누락' }));
      return false;
    }
    if (quantity > 1) {
      dispatch(
        toast.error({
          message: '2부 이상 신청의 경우  02)701-7421로 연락 바랍니다.',
          title: '필수 입력 항목 누락',
        })
      );
      return false;
    }
    if (email.length <= 0 || !emailRule.test(email)) {
      dispatch(toast.error({ message: '이메일을 확인하세요.', title: '필수 입력 항목 누락' }));
      return false;
    }
    if (hp.length <= 0 || !cellPhoneRule.test(hp)) {
      dispatch(toast.error({ message: '전화번호를 확인하세요.', title: '필수 입력 항목 누락' }));
      return false;
    }
    if (address.length <= 0) {
      dispatch(toast.error({ message: '주소를 입력해주세요.', title: '필수 입력 항목 누락' }));
      return false;
    }
    return true;
  }

  const searchFunction = () => {
    setCurrentPage(1);
    setLast(false);
    setListItem(undefined);
  };

  const getBookList = useCallback(async () => {
    setLoading(true);
    if (searchText.trim().length === 0) {
      await server
        .AllBookList(currentPage, 10)
        .then((payload) => {
          if (!payload) {
            dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
          } else if (payload.code === 260 || payload.code === 500) {
            dispatch(toast.error({ message: '파라미터 오류' }));
          } else {
            const ar = listItem === undefined ? payload.items : listItem.concat(payload.items);
            setListItem(ar);

            if (payload.meta.totalPages === payload.meta.currentPage) {
              setLast(true);
            }
          }
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });
    } else {
      await server
        .searchBooks(currentPage, 10, searchText, '', '', '')
        .then((payload) => {
          if (!payload) {
            dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
          } else if (payload.code === 260 || payload.code === 500) {
            dispatch(toast.error({ message: '파라미터 오류' }));
          } else {
            const ar = listItem === undefined ? payload.items : listItem.concat(payload.items);
            setListItem(ar);
            if (payload.meta.totalPages < currentPage) {
              setCurrentPage((prevState) => prevState - 1);
              setLast(true);
            }
            console.log('끝', currentPage);
          }
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });
    }
    setLoading(false);
  }, [currentPage]);

  useEffect(() => {
    getBookList();
  }, [getBookList]);

  // 주소창 강제이동 또는 관리자 권한이 없는 사용자 → 메인페이지 이동
  useEffect(() => {
    if (
      window.localStorage.getItem('token') === null ||
      (window.localStorage.getItem('part') !== 'professor' &&
        window.localStorage.getItem('authority') !== 'A')
    ) {
      dispatch(toast.error({ message: '교수 회원님 전용 공간입니다.' }));
      history.push('/');
    }
  }, []);

  useEffect(() => {
    // 사용자가 마지막 요소를 보고 있고, 로딩 중이 아니라면
    if (inView && !loading && !last) {
      setCurrentPage((prevState) => prevState + 1);
    }
  }, [inView, loading]);

  const bookList = () => {
    return (
      <section className="books-results">
        <div className="table">
          <ul className="row title">
            <li className="book-image">사진</li>
            <li className="book-information">정보</li>
            <li className="buttons">버튼</li>
          </ul>
          {listItem?.map((it: any) => (
            <ul key={it.isbn + Math.floor(Math.random() * 9000) + 1000} className="row">
              <li className="book-image">
                <img src={it.imageMiddleUrl} alt="" />
              </li>
              <li className="book-information">
                <div className="isbn">
                  <span>ISBN</span>
                  <span>{it.isbn}</span>
                </div>
                <div className="book-title">
                  <span>상품명</span>
                  <span>{it.name}</span>
                </div>
                <div className="book-writer">
                  <span>저자</span>
                  <span>{it.author}</span>
                </div>
                <div className="price">
                  <span>단가</span>
                  <span>{Number(it.priceFull).toLocaleString()}</span>
                </div>
              </li>
              {Number(it.qty) !== 0 ? (
                <li className="buttons">
                  <button
                    type="button"
                    onClick={() => {
                      setBook(it);
                      setSearchVisable(false);
                    }}
                  >
                    선택
                  </button>
                </li>
              ) : (
                <li className="buttons">
                  <span style={{ color: 'tomato' }}>재고 없음</span>
                </li>
              )}
            </ul>
          ))}
          <div ref={ref} />
        </div>
      </section>
    );
  };

  return (
    <>
      <main className="sub wrapper">
        <AsideProfessor />
        <div className="content">
          {getBreadScrumb('견본도서요청', '교수님 전용')}
          {GetTitle(
            '',
            '견본도서요청',
            '도서출판 구민사는 교수님들을 위한 견본도서를 지원하고 있으며, 2부 이상 요청을 원하시는 교수님께서는 당사 02)701-7421로 연락바랍니다.',
            '',
            '',
            false,
            () => {},
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            (param: string) => {},
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            (param: string) => {}
          )}
          <section>
            <ul className="inputs">
              <li className="choose-books">
                <span className="required">신청도서</span>
                <button
                  type="button"
                  onClick={() => {
                    setSearchVisable(true);
                    setCurrentPage(1);
                    setLast(false);
                    setListItem(undefined);
                  }}
                >
                  도서등록
                </button>
                <span className="result">{book?.name}</span>
              </li>
              <li>
                <span className="required">저자</span>
                <input type="text" defaultValue={book === undefined ? '' : book.author} readOnly />
              </li>
              <li>
                <span className="required">판권날짜</span>
                <input
                  type="text"
                  defaultValue={
                    book !== undefined ? new Date(book?.publicationDate).toLocaleDateString() : ''
                  }
                  readOnly
                />
              </li>
              <li>
                <span>수량</span>
                <input
                  type="number"
                  value={quantity}
                  onChange={(dom) => {
                    setQuantity(Number(dom.target.value));
                  }}
                  readOnly
                />
                <small>※ 2부 이상은 별도 문의 바랍니다.</small>
              </li>
              <li>
                <span className="required">이름</span>
                <input
                  type="text"
                  defaultValue={window.localStorage.getItem('name') || ''}
                  readOnly
                />
              </li>
              <li>
                <span className="required">대학명</span>
                <input
                  type="text"
                  defaultValue={window.localStorage.getItem('college') || ''}
                  readOnly
                />
              </li>
              <li>
                <span className="required">학과</span>
                <input
                  type="text"
                  defaultValue={window.localStorage.getItem('department') || ''}
                  readOnly
                />
              </li>
              <li>
                <span className="required">이메일</span>
                <input
                  type="email"
                  value={email}
                  onChange={(dom) => {
                    setEmail(dom.target.value);
                  }}
                />
              </li>
              <li className="phone">
                <span className="required">휴대폰</span>
                <div>
                  <input
                    type="number"
                    value={phone1}
                    onChange={(dom) => {
                      setPhone1(dom.target.value);
                    }}
                  />
                  <span>-</span>
                  <input
                    type="number"
                    value={phone2}
                    onChange={(dom) => {
                      setPhone2(dom.target.value);
                    }}
                  />
                  <span>-</span>
                  <input
                    type="number"
                    value={phone3}
                    onChange={(dom) => {
                      setPhone3(dom.target.value);
                    }}
                  />
                </div>
              </li>

              <li className="address">
                <span className="required">주소</span>
                <input
                  type="text"
                  value={address}
                  onChange={(dom) => {
                    setAddress(dom.target.value);
                  }}
                />
              </li>
              <li>
                <span className="required">내용</span>
                <textarea
                  rows={10}
                  value={contents}
                  onChange={(dom) => {
                    setContents(dom.target.value);
                  }}
                />
              </li>
            </ul>
            <div className="buttons">
              <button
                type="button"
                className="btn-main"
                onClick={() => {
                  if (validation()) {
                    server
                      .requestSampleBook({
                        isbn: book.isbn,
                        bookCount: quantity,
                        phone: `${phone1}-${phone2}-${phone3}`,
                        email,
                        post: '',
                        address,
                        content: contents,
                        bookId: book.id,
                      })
                      .then((payload) => {
                        if (!payload) {
                          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
                        } else if (payload.code === 260 || payload.code === 500) {
                          dispatch(toast.error({ message: '파라미터 오류' }));
                        } else {
                          dispatch(toast.info({ message: '신청 되었습니다.' }));
                          setBook(undefined);
                          setQuantity(1);
                          setEmail('');
                          setPhone1('');
                          setPhone2('');
                          setPhone3('');
                          setAddress('');
                          setContents('');
                          setSearchText('');
                        }
                      });
                  }
                }}
              >
                신청하기
              </button>
            </div>
          </section>
        </div>
      </main>
      <div className={`modal modal-books ${searchVisable ? 'active' : ''}`}>
        <header>
          <div className="title">
            <h3>견본요청 도서 선택</h3>
            <svg
              className="close"
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 18 18"
              onClick={() => {
                setSearchVisable(false);
              }}
            >
              <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z" />
            </svg>
          </div>
          <section className="search">
            <input
              type="text"
              placeholder="도서명을 입력하세요."
              value={searchText}
              onChange={(dom) => {
                setSearchText(dom.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  searchFunction();
                }
              }}
            />
            <button
              type="button"
              onClick={() => {
                searchFunction();
              }}
            >
              검색
            </button>
          </section>
        </header>
        <div className="modal-content">{bookList()}</div>
      </div>
      <div className={`overlay ${searchVisable ? 'active' : ''}`} />
    </>
  );
}
